exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-part[data-v-376203e6]{margin-bottom:15px\n}\n", ""]);

// exports
